import { render } from "./OverlayMenuSmall.vue?vue&type=template&id=917f96fe&scoped=true"
import script from "./OverlayMenuSmall.vue?vue&type=script&lang=js"
export * from "./OverlayMenuSmall.vue?vue&type=script&lang=js"

import "./OverlayMenuSmall.vue?vue&type=style&index=0&id=917f96fe&scoped=true&lang=css"

import exportComponent from "D:\\presta\\dev\\key4access\\key4access.front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-917f96fe"]])

export default __exports__